<footer class="footer-border">
    <div class="d-flex justify-content-md-between justify-content-center align-items-center mx-3 flex-wrap">
        <div class="d-flex align-items-center gap-1">
            <img src="../../../../../assets/img/toyota-silver.png" alt="TMNA Logo" class="img-alg-footer-logo cu">
            <span class="hcm-footer-text">{{ 'footer.copyright' | translate }}</span>
        </div>
        <nav>
            <ul class="nav">
                <a><span class="hcm-footer-link-text cu">{{ 'footer.links.termsOfUse' | translate
                        }}</span><span class=""></span></a>
                        <span class="divider"></span>
                <a><span class="hcm-footer-link-text cu">{{ 'footer.links.contactUs' | translate
                        }}</span><span class=" "></span></a>
                        <span class="divider"></span>
                <a><span class="hcm-footer-link-text cu">{{ 'footer.links.privacyPolicy' | translate
                        }}</span></a>
            </ul>
        </nav>
    </div>
</footer>